import { useEffect } from 'react'

/**
 * Esta pantalla solo es válida para ROLE_ADMIN_MAGENTA con tenantId en location.state.
 */
const useMagentaTenantGuard = (history, location) => {
    const tenantId = location.state?.tenantId
    const tenantNombre = location.state?.tenantNombre

    useEffect(() => {
        try {
            const token = JSON.parse(
                atob(sessionStorage.getItem('token').split('.')[1])
            )
            const rol = token.authorities[0]
            const tid = location.state?.tenantId
            if (rol !== 'ROLE_ADMIN_MAGENTA' || !tid) {
                history.goBack()
            }
        } catch {
            history.goBack()
        }
    }, [history, location.state?.tenantId])

    return { tenantId, tenantNombre }
}

export default useMagentaTenantGuard
